import React from "react";
import { KPIGrid } from "../charts/KPIGrid";

export const ExecutiveKPIs: React.FC = () => {
  return <KPIGrid />;
};
